<template>
  <RouterLink
    :to="{ name: 'Story', params: { slug: slug } }"
    class="flex flex-col lg:flex-row w-full transition-opacity"
    :class="{ 'opacity-0': !imageLoaded }"
    :style="style"
  >
    <div
      class="w-full lg:w-1/2 font-title flex flex-col text-center p-5 relative min-h-32"
    >
      <h3 class="text-1-mob lg:text-3-desk absolute mx-auto center-absolute">
        STORIES
      </h3>
      <h2 class="uppercase tex-4-mob lg:text-5-desk m-auto">{{ title }}</h2>
    </div>
    <div class="w-full lg:w-1/2">
      <CoreImage
        class="w-full h-32 lg:h-64 object-cover"
        :image="image"
        :sizes="sizes"
        @load="imageLoaded = true"
      />
    </div>
  </RouterLink>
</template>

<script>
import { colors } from "@utils/tailwind";
import { sizesHelper } from "@c/Core/CoreImage";

export default {
  name: "DirectoryStoryTile",

  props: {
    title: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    image: {
      type: Object
    },
    slug: {
      type: String,
      default: ""
    }
  },

  data: () => ({
    imageLoaded: false
  }),

  computed: {
    sizes() {
      return sizesHelper([["screen-xl", 2], "100vw"]);
    },
    style() {
      return {
        backgroundColor: colors[this.color]
      };
    }
  }
};
</script>

<style scoped>
.center-absolute {
  left: 50%;
  transform: translateX(-50%);
}
</style>
